import "core-js/modules/web.dom.iterable";
//
//
//
//
import barLineChart from '@/components/bigDataChart/barLineChart';
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { queryCurveAnalysisSx } from '@/api/api';
import moment from 'moment';
export default {
  name: 'waterStatistics',
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '250px'
    }
  },
  components: {
    barLineChart: barLineChart
  },
  mounted: function mounted() {
    this.queryWaterStatistics();
  },
  methods: {
    queryWaterStatistics: function queryWaterStatistics() {
      var _this = this;

      var dateTime = new Date();
      var that = this;
      var yAxisData1 = [];
      var yAxisData2 = [];
      var yAxisData3 = [];
      var yAxisData4 = [];
      var yAxisData5 = [];
      var yAxisData6 = [];
      var xAxisData = [];
      queryCurveAnalysisSx({
        factorCategory: '11',
        id: '8',
        type: 0
      }).then(function (res) {
        if (res.success) {
          res.result.data.forEach(function (element) {
            yAxisData1.push(element.dataCodeMap['u10101'].value);
            yAxisData2.push(element.dataCodeMap['u10201'].value);
            yAxisData3.push(element.dataCodeMap['u10401'].value);
            yAxisData4.push(element.dataCodeMap['u10501'].value);
            yAxisData5.push(element.dataCodeMap['u10901'].value);
            yAxisData6.push(element.dataCodeMap['u10302'].value);
            xAxisData.push(element.dateStr);
          });
          var data = {
            color: ['#8B5CFF', '#00CA69', '#898b37', '#ff9900', '#333399', '#cc9999'],
            title: ['水温', 'pH', '电导率', '溶解氧', '原水浊度', '河埠头浊度'],
            xAxisData: xAxisData,
            yAxisList: [yAxisData1, yAxisData2, yAxisData3, yAxisData4, yAxisData5, yAxisData6],
            unit: '',
            height: 140
          };

          _this.$refs.chart2.initBarLineChart(data);
        }
      });
    }
  }
};